import UserService, {ROLE_SUPER_ADMIN} from "api/user/user";
export default function ModuleConfigurationVoter() {
    const canAccessModuleConfiguration = () => {
        return UserService.getRoles().includes(ROLE_SUPER_ADMIN);
    }
    return ({canAccessModuleConfiguration})
}